var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c(_vm.$route.meta.layout || 'div',{tag:"component"},[_c('router-view')],1),(_vm.$store.getters.getIsLoadingOn)?_c('loading'):_vm._e(),(this.$store.state.loginModal === true)?_c('loginAlertPopup',{on:{"loginModalUpdate":_vm.updateloginModal}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }